enum RequestStatus {
    SUCCESS = 'success',
    ERROR = 'error',
    LOADING = 'loading',
    UPDATING = 'updating',
    NOT_LOADED = 'notLoaded',
}

export default RequestStatus;